import { render, staticRenderFns } from "./AttributeTemplatesForm.vue?vue&type=template&id=700c5f43&"
import script from "./AttributeTemplatesForm.vue?vue&type=script&lang=js&"
export * from "./AttributeTemplatesForm.vue?vue&type=script&lang=js&"
import style0 from "./AttributeTemplatesForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports